import { E_ProcessEnv, getAppEnv, getProcessEnv, isNodeProd, liteset, swimlane } from '../base/env'

const appEnv = getAppEnv()

export const ERROR_MESSAGE: Record<string, string> = {
  'Request aborted': '请求终止',
  'Network Error': '网络请求错误，请重试',
  'Request failed with status code 404': '请求错误404',
  'timeout of 60000ms exceeded': '请求超时，请重试',
  'timeout of 10000ms exceeded': '请求超时，请重试',
}

export const baseURL = (() => {
  let baseURL = getProcessEnv(E_ProcessEnv.VUE_APP_API_HOST) || ''
  if (swimlane) {
    return '//' + swimlane + '-sl-' + baseURL.slice(2)
  }
  return baseURL
})()

if (!isNodeProd()) {
  const i = document.createElement('b')
  i.setAttribute('owl-ignore', '')
  i.innerHTML = '当前环境' + [liteset, swimlane ? swimlane : appEnv].filter((i) => i).join(':')
  i.setAttribute('style', 'position:fixed;bottom:0;left:0;background:rgba(0, 0, 0, .2);color:#fff;z-index:9999;')
  document.body.appendChild(i)
}
